import { MAX_FAILED_ELECTIONS } from 'shared';
import { ro } from '../i18n/ro';
import { cx } from './tokens';

/**
 * The election tracker, always on screen rather than only when it matters —
 * three filled boxes is the table's warning that chaos is one vote away.
 */
export function Tracker({
  failedElections,
  size = 'md',
  className,
}: {
  failedElections: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const boxes = {
    sm: 'h-3 w-3 border-2',
    md: 'h-5 w-5 border-2',
    lg: 'h-[2.2vh] w-[2.2vh] min-h-4 min-w-4 border-[3px]',
  } as const;

  const text = {
    sm: 'text-[0.6rem]',
    md: 'text-xs',
    lg: 'text-screen-sm',
  } as const;

  return (
    <div
      className={cx('flex items-center gap-3', className)}
      data-testid="tracker"
      data-failed={failedElections}
    >
      <div className="flex gap-1.5">
        {Array.from({ length: MAX_FAILED_ELECTIONS }, (_, i) => (
          <div
            key={i}
            className={cx(
              'border-ink',
              boxes[size],
              i < failedElections ? 'bg-red' : 'bg-transparent',
            )}
          />
        ))}
      </div>
      <span className={cx('deco-caps text-ink-soft', text[size])}>
        {ro.failedElections(failedElections, MAX_FAILED_ELECTIONS)}
      </span>
    </div>
  );
}
